import { render, staticRenderFns } from "./PhotographyStudioSection.vue?vue&type=template&id=2bdbf4f6"
import script from "./PhotographyStudioSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyStudioSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyStudioSection.vue?vue&type=style&index=0&id=2bdbf4f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports